import React, { useState, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import Button from "@restart/ui/esm/Button";

const AccredList = () => {
  const [rowData, setRowData] = useState([]);
  const [rowDataExport, setRowDataExport] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const gridRef = useRef();

  useEffect(() => {
    let url = process.env.REACT_APP_ACCRED_PHYSICIAN_API;
    console.log("url: " + url);
    fetch(url)
      .then((result) => result.json())
      .then((rowData) => setRowData(rowData))
      .then((rowDataExport) => setRowDataExport(rowData));
  }, []);

  const [columns] = useState([
    {
      headerName: "Provider Name, City, State, Zip",
      field: "provider",
      filter: true,
      wrapHeaderText: true,
      floatingFilter: true,
      autoHeaderHeight: true,
      wrapText: true,
      autoHeight: true,
      suppressMenu: true,
      floatingFilterComponentParams: {suppressFilterButton: true},
      rowSelection: 'single',
      suppressCellSelection: true, 
      suppressMovable: true,
      cellClass: "",
      cellStyle: {
        "white-space": "normal",
        "line-height": 1.5,
        "font-size": "0.688rem",
      },
      cellRenderer: (params) => {
        var a = document.createElement("div");
        a.innerHTML =
          "<b>" +
          params.data.lastName +
          ", " +
          params.data.firstName +
          " " +
          params.data.middleName +
          "</b>" +
          "<div>" +
          params.data.attentionAddress +
          "</div>" +
          "<div>" +
          params.data.street +
          "</div><div>" +
          params.data.city +
          ", " +
          params.data.state +
          " " +
          params.data.zip +
          "</div><div>" +
          "<b>" +
          params.data.phone +
          "</b>";
        return a;
      },
    },
    {
      headerName: "Speciality",
      field: "speciality",
      filter: true,
      floatingFilter: true,
      wrapText: true,
      autoHeight: true,
      suppressMenu: true,
      floatingFilterComponentParams: {suppressFilterButton: true},
      suppressMovable: true,
      cellStyle: {
        "white-space": "normal",
        "line-height": 1.5,
        "font-size": "0.688rem",
        "text-align": "left"
      },
      cellClass: "",
      width: "14.375 rem",
      "text-align": "center"
    },
    {
      headerName: "Credential",
      field: "degree",
      floatingFilter: true,
      filter: true,
      wrapText: true,
      autoHeight: true,suppressMenu: true,
      floatingFilterComponentParams: {suppressFilterButton: true},
      suppressMovable: true,
      cellClass: "",
      cellStyle: {
        "white-space": "normal",
        "line-height": 1.5,
        "font-size": "0.688rem",
        "text-align": "center !important",
        "justify-content": "center"
      },
    },
  
    {
      headerName: "License",
      field: "licenseId",
      filter: true,
      floatingFilter: true,suppressMenu: true,
      floatingFilterComponentParams: {suppressFilterButton: true},
      suppressMovable: true,
      cellStyle: {
        "white-space": "normal",
        "line-height": 1.5,
        "font-size": "0.688rem",
      },
    },
    {
      headerName: "NPI",
      field: "nationalProviderId",
      filter: true,
      floatingFilter: true,suppressMenu: true,
      floatingFilterComponentParams: {suppressFilterButton: true},
      suppressMovable: true,
      cellStyle: {
        "white-space": "normal",
        "line-height": 1.5,
        "font-size": "0.688rem",
      },
    },
  
    {
      headerName: "Accred Level",
      field: "level",
      filter: true,
      floatingFilter: true,
      width: "4.375rem",suppressMenu: true,
      floatingFilterComponentParams: {suppressFilterButton: true},
      suppressMovable: true,
      cellStyle: {
        "white-space": "normal",
        "line-height": 1.5,
        "font-size": "0.688rem",
      },
    },
    {
      headerName: "F=Full L=Limited",
      field: "levelType",
      filter: true,
      floatingFilter: true,suppressMenu: true,
      floatingFilterComponentParams: {suppressFilterButton: true},
      suppressMovable: true,
      cellStyle: {
        "white-space": "normal",
        "line-height": 1.5,
        "font-size": "0.688rem",
      },
    },
    {
      headerName: "Eff. Date",
      field: "accredDate",
      filter: true,
      floatingFilter: true,suppressMenu: true,
      floatingFilterComponentParams: {suppressFilterButton: true},
      suppressMovable: true,
      cellStyle: {
        "white-space": "normal",
        "line-height": 1.5,
        "font-size": "0.688rem",
      },
    },
    {
      headerName: "Exp. Date",
      field: "accredExpire",
      filter: true,
      floatingFilter: true,suppressMenu: true,
      floatingFilterComponentParams: {suppressFilterButton: true},
      suppressMovable: true,
      cellStyle: {
        "white-space": "normal",
        "line-height": 1.5,
        "font-size": "0.688rem",
      },
    },
  ]);

  const defaultColDef = {
    resizable: true,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    initialWidth: "1.25 rem",
    cellClass: 'center-text'
  };

  const onDataAutoSizeColumns = (params) => {
    const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
    params.columnApi.autoSizeColumns(colIds);
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const csvExport = () => {
    gridApi.exportDataAsCsv();
  };


  const highlightSomeRows = (params) => {
    console.log(params);

    if (params.data.highlighter === "Y") {
      return { "background-color": "yellow", "font-style": "italic" };
    }
  };


  useEffect(() => {
    let buttons = document.getElementsByClassName('ag-paging-button');
    let headerLabel = document.getElementsByClassName('ag-header-cell');
    let iconBtn = document.getElementsByClassName('ag-header-icon');
    let headerLabelContainer = document.getElementsByClassName('ag-cell-label-container');
    let agIconNone = document.getElementsByClassName('ag-icon-none');
    let agFilterIcon = document.getElementsByClassName('ag-icon-filter');
    const col = document.querySelectorAll('[col-id="accredDate"]');

    setTimeout(function(){if(col){
      console.log(col);
      col.forEach((c) => {
        c.style.textAlign = "center";
      })
    }}, 100)
    


    if(agIconNone.length > 0){
      Array.from(agIconNone).forEach((icon) =>{
        icon.style.display = 'none';
      })
    }

    if(agFilterIcon.length > 0){
      Array.from(agFilterIcon).forEach((icon) =>{
        icon.style.display = 'none';
      })
    }

    if(iconBtn.length > 0){
      Array.from(iconBtn).forEach((button) => {
        button.classList.remove('ag-hidden');
            })
    }

    if (buttons.length > 0) {
      Array.from(buttons).forEach((button, index) => {
        button.addEventListener('click', () => {
          console.log(headerLabel);
          headerLabel[0].focus();
          window.scrollTo(0,0);
        });
        button.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            window.scrollTo(0, 0);
            headerLabel[0].focus();
            console.log('Enter key hit');
          } else {
            console.log('Other key pressed');
          }
        });        
      });
    }
  }, []);



  const gridOptions = {
    defaultCellClass: 'center-text',
    autoSizeStrategy: {
      type: 'fitGridWidth',
      defaultMinWidth: 100,
      columnLimits: [
        {
          colId: 'country',
          minWidth: 200
        }
      ]
    },
    defaultColDef: defaultColDef,
    onFirstDataRendered: onDataAutoSizeColumns,
    rowSelection: 'single',
    suppressCellSelection: true, 
    suppressCellFocus: true,
  };

  //add placeholder text to inputs

  let inputs = document.querySelectorAll('input');

  inputs.forEach((input) => {
    input.setAttribute("placeholder", "Search");
  })

  //ada stuff

  const labelContainer = document.querySelectorAll('.ag-cell-label-container');
  const tableWrapper = document.querySelectorAll('[role="grid"]');

  tableWrapper.forEach((wrapper) =>{
    wrapper.setAttribute('aria-label', 'Accredited Provider Directory; searchable or sortable by column header');
  })
  
  labelContainer.forEach((label) => {
    label.removeAttribute('role');
    label.setAttribute('role', 'button');
  })

  

  return (
    <>

    <div
      id="myGrid"
      className="ag-theme-alpine"
      style={{   "maxWidth": "100vw",
        "width": "90%",
        "margin": "0 auto",
      "height": "100vh", }}
    >
         <div className="example-header csvBtn">
    <Button className="btn btn-link" onClick={csvExport}>
    Export to CSV file
    </Button>
  </div>
      <AgGridReact
        rowSelection={"single"}
        onGridReady={onGridReady}
        rowData={rowData}
        columnDefs={columns}
        defaultColDef={defaultColDef}
        pagination={true}
        paginationPageSize={10}
        onFirstDataRendered={onDataAutoSizeColumns}
        getRowStyle={highlightSomeRows}
        ref={gridRef}      
        gridOptions = {gridOptions}
      ></AgGridReact>
    </div>
    </>
  );
};

export default AccredList;
